import { useLazyQueryInterop } from '@confluence/apollo-relay-interop';
import { ConfluenceSmartCreationModalQuery } from './ConfluenceSmartCreationModalQuery';
import { type ConfluenceSmartCreationModalQuery as ConfluenceSmartCreationModalQueryResult } from './__types__/ConfluenceSmartCreationModalQuery';

export const usePreloadSmartCreationModalQuery = () => {
	const [preloadSmartCreationModalQuery] =
		useLazyQueryInterop<ConfluenceSmartCreationModalQueryResult>(ConfluenceSmartCreationModalQuery);

	return { preloadSmartCreationModalQuery };
};
